type FbqWindow = Window & {
  fbq?: (...args: unknown[]) => void
}

/** Fires a standard Meta Pixel event if the pixel is present. */
export function track(event: 'ViewContent' | 'InitiateCheckout' | 'Purchase'): void {
  if (typeof window === 'undefined') return
  const fbq = (window as FbqWindow).fbq
  if (typeof fbq === 'function') fbq('track', event)
}
